import React from "react";
import { ShieldAlert } from "lucide-react";
import { formatTime } from "@/util/call";

interface FlagActivityItemProps {
  preview: string;
  phoneNumber?: string;
  timestamp: string;
}

const FlagActivityItem: React.FC<FlagActivityItemProps> = ({ preview, phoneNumber, timestamp }) => {
  return (
    <div className="flex items-center gap-2 px-4 py-3 text-sm text-muted-foreground">
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="min-w-0 flex-1 truncate">
        {preview}
        {phoneNumber ? ` · ${phoneNumber}` : ""}
      </span>
      <span className="shrink-0 text-xs">{formatTime(new Date(timestamp))}</span>
    </div>
  );
};

export default FlagActivityItem;
